import { Close } from '@mui/icons-material'
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography
} from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'

const InventoryUpdateDailog = ({
  visibility,
  currentStock,
  initialValues,
  onSubmit,
  onClose
}) => {
  if (initialValues === undefined) {
    initialValues = {
      name: '',
      stock: '',
      remarks: ''
    }
  }

  const handleSubmit = (values) => {
    onSubmit(values)
  }

  return (
    <>
      <Dialog
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={visibility}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          Stock Update
          <IconButton
            component="span"
            size="small"
            sx={{ ':hover': { backgroundColor: 'red', color: 'white' } }}
            onClick={onClose}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={Yup.object().shape({
              stock: Yup.number()
                .required('Stock is required')
                .test('non-zero', "Stock can't be zero", (value) => value !== 0)
                .test(
                  'decimal',
                  'Stock can have up to 3 decimal places',
                  (value) => {
                    // Convert the number to a string and check if it has more than 3 decimal places
                    return !/\d+\.\d{4,}/.test(value?.toString())
                  }
                ),
              remarks: Yup.string()
                .required('Remarks is required')
                .min(2, 'Min 2 characters is required')
            })}
          >
            {({
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              touched,
              errors
            }) => (
              <form onSubmit={handleSubmit}>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={5} style={{ paddingTop: 10 }}>
                  <Grid item>
                    <Typography
                      variant="subtitle"
                      color={'primary'}
                      sx={{ fontWeight: 'bold' }}
                      gutterBottom
                    >
                      {values?.name}{' '}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item>
                    <Typography
                      variant="subtitle"
                      sx={{ fontWeight: 'bold' }}
                      gutterBottom
                    >
                      Current Stock
                    </Typography>
                  </Grid>
                  <Grid item sx={{ pl: 1 }}>
                    <Typography
                      variant="subtitle"
                      color={'primary'}
                      sx={{ fontWeight: 'bold' }}
                      gutterBottom
                    >
                      {currentStock ?? 0}{' '}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item md>
                    <TextField
                      fullWidth
                      label="Stock Update"
                      variant="outlined"
                      name="stock"
                      margin="dense"
                      type="number"
                      value={values.stock}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.stock && errors.stock)}
                      helperText={touched.stock && errors.stock}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item md>
                    <TextField
                      label="Remarks"
                      variant="outlined"
                      name="remarks"
                      fullWidth
                      margin="dense"
                      multiline
                      value={values.remarks}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.remarks && errors.remarks)}
                      helperText={touched.remarks && errors.remarks}
                    />
                  </Grid>
                </Grid>
                <Grid container mt={2} justifyContent={'flex-end'}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="success"
                      type="submit"
                      sx={{
                        transition: 'box-shadow 0.3s ease',
                        borderRadius: 1,
                        '&:hover': {
                          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
                          backgroundColor: '#4caf50',
                          color: '#fff'
                        }
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default InventoryUpdateDailog
